import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';
import * as Styles from '../Icon.module.scss';

export const ElementarySchoolIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    const iconSize = IconSizes[size];
    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.29737 10.2131L11.2974 4.28844C11.6869 3.90385 12.3131 3.90385 12.7026 4.28844L18.7026 10.2131C18.8929 10.401 19 10.6573 19 10.9247V20H21C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H18H14H10H6H3C2.44772 22 2 21.5523 2 21C2 20.4477 2.44772 20 3 20H5V10.9247C5 10.6573 5.1071 10.401 5.29737 10.2131ZM11 20H13V15H11V20ZM15 20V14C15 13.4477 14.5523 13 14 13H10C9.44772 13 9 13.4477 9 14V20H7V11.342L12 6.405L17 11.343V20H15Z"
            />
        </svg>
    );
};
